<template>
  <b-modal
    v-model="isShown"
    no-close-on-backdrop
    hide-header
    hide-footer
    centered
    no-fade
  >
    <form
      id="unloginModal"
      @submit.prevent="redirect"
    >
      <div class="modal-body unloginModal">
        <h2 class="modal-title">
          {{ text }}
        </h2>
        <button
          type="submit"
          class="btn btn-primary-ford-orange modal-ext"
        >
          Авторизоваться
        </button>
      </div>
    </form>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'SignOutModal',
  data: () => ({
    isShown: false,
    text: '',
  }),
  computed: {
    ...mapState(['signOutModal']),
  },
  watch: {
    signOutModal: {
      /* eslint-disable */
      handler: function({ isShown, text }) {
        this.isShown = isShown;
        this.text = text;
        this.$store.commit('setBackgroundBlur', isShown);
      },
      deep: true,
    },
  },
  mounted() {
    if (this.isShown) {
      this.$store.commit('setBackgroundBlur', true);
    }
  },
  methods: {
    redirect() {
      this.$store.commit('logOut');
      this.$store.commit('toggleSignOutModal', {
        isShown: false,
        text: '',
      });

      this.$router.push({
        path: '/sign-in',
        query: { redirect: this.$route.fullPath },
      });
    },
  },
};
</script>
